module.exports = {
  t: 'total',
  //c: 'commitment',
  //f: 'freedom',
  //p: 'privacy'
};
